@import (reference) '../../../styles/variables.less';

:host {
  display: block;
}

ltc-input-text {
  color: @lt-blue-deep;
  min-width: 120px;

  label {
    color: @lt-gray-dark-2;
  }
}
